<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Distribuidor / CCSS</strong>
          </div>
          <b-form-fieldset label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"  v-validate="'required'" :state="validateState('name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-row>
            <b-form-fieldset label="Código" class="col-sm-4">
              <b-form-input type="text" name="code" v-model="item.code" placeholder="Código"  v-validate="'required'" :state="validateState('code')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('code') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
            <b-form-fieldset label="Tipo" class="col-sm-4">
              <b-form-select :options="dealerTypes" name="dealer_type" v-model="item.dealer_type" placeholder="Estado"  v-validate="'required'" :state="validateState('dealer_type')" ></b-form-select>

              <b-form-invalid-feedback>
                {{ errors.first('code') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
            <b-form-fieldset label="Estado" class="col-sm-4">
              <b-form-select :options="stateOptions" name="state" v-model="item.state" placeholder="Estado"  v-validate="'required'" :state="validateState('state')" ></b-form-select>

              <b-form-invalid-feedback>
                {{ errors.first('code') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
          </b-form-row>
          <b-form-row>
            <b-form-fieldset label="SO" class="col-sm-3">
              <b-form-input type="text" name="dealer_so_code" v-model="item.dealer_so_code" placeholder="SO" ></b-form-input>
            </b-form-fieldset>
            <b-form-fieldset label="ST" class="col-sm-3">
              <b-form-input type="text" name="dealer_st_code" v-model="item.dealer_st_code" placeholder="ST" ></b-form-input>
            </b-form-fieldset>
            <b-form-fieldset label="CADV" class="col-sm-3">
              <b-form-input type="text" name="dealer_cadv_code" v-model="item.dealer_cadv_code" placeholder="CADV" ></b-form-input>
            </b-form-fieldset>
            <b-form-fieldset label="CHA" class="col-sm-3">
              <b-form-input type="text" name="dealer_cha_code" v-model="item.dealer_cha_code" placeholder="CHA" ></b-form-input>
            </b-form-fieldset>
          </b-form-row>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'dealers.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Códigos UFS</strong>
          </div>
          <div class="form-row" v-for="(codigo, index) in item.dealerufs.data">
            <b-form-group class="col-md-3">
              <input type="text" v-model="codigo.ufs_id" class="form-control" placeholder="Código UFS" />
            </b-form-group>
            <b-form-group description="(AAAA-mm-dd)" class="col-md-3">
              <input type="text" v-model="codigo.date_start" v-mask="'####-##-##'" class="form-control" placeholder="Data de ínicio" />
            </b-form-group>
            <b-form-group description="(AAAA-mm-dd)" class="col-md-3">
              <input type="text" v-model="codigo.date_end" v-mask="'####-##-##'" class="form-control" placeholder="Data de fim" />
            </b-form-group>
            <b-form-group class="col-md-3" v-if="item.dealerufs.data.length>1">
              <b-button variant="danger" v-on:click="removeDealerUFS(index)"><i class="fa fa-times"></i></b-button>
            </b-form-group>
          </div>
          <button type="button" v-on:click="addDealerUFS()" class="btn btn-primary" ><i class="fa fa-plus"></i> Adicionar código</button>
        </b-card>
        <b-card>
          <div slot="header">
            <strong>Sellin Shipto</strong>
          </div>
          <div class="form-row" v-for="(codigo, index) in item.dealersellin.data">
            <b-form-group class="col-md-3">
              <input type="text" v-model="codigo.shipto" class="form-control" placeholder="Shipto" />
            </b-form-group>
            <b-form-group description="(AAAA-mm-dd)" class="col-md-3">
              <input type="text" v-model="codigo.date_start" v-mask="'####-##-##'" class="form-control" placeholder="Data de ínicio" />
            </b-form-group>
            <b-form-group description="(AAAA-mm-dd)" class="col-md-3">
              <input type="text" v-model="codigo.date_end" v-mask="'####-##-##'" class="form-control" placeholder="Data de fim" />
            </b-form-group>
            <b-form-group class="col-md-3" v-if="item.dealersellin.data.length>1">
              <b-button variant="danger" v-on:click="removeDealerSellin(index)"><i class="fa fa-times"></i></b-button>
            </b-form-group>
          </div>
          <button type="button" v-on:click="addDealerSellin()" class="btn btn-primary" ><i class="fa fa-plus"></i> Adicionar código</button>
        </b-card>
        <b-card>
          <div slot="header">
            <strong>Zonas</strong>
          </div>
          <div class="form-row" v-for="(zone, index) in item.zones.data">
            <b-form-group class="col-md-5">
              <input type="text" v-model="zone.name" class="form-control" placeholder="Nome Zona" />
            </b-form-group>
            <b-form-group class="col-md-2">
              <input type="text" v-model="zone.zone" class="form-control" placeholder="Código Zona" />
            </b-form-group>
            <b-form-group description="(AAAA-mm-dd)" class="col-md-2">
              <input type="text" v-model="zone.date_start" v-mask="'####-##-##'" class="form-control" placeholder="Data de ínicio" />
            </b-form-group>
            <b-form-group description="(AAAA-mm-dd)" class="col-md-2">
              <input type="text" v-model="zone.date_end" v-mask="'####-##-##'" class="form-control" placeholder="Data de fim" />
            </b-form-group>
            <b-form-group class="col-md-1" v-if="item.dealerufs.data.length>1">
              <b-button variant="danger" v-on:click="removeZone(index)"><i class="fa fa-times"></i></b-button>
            </b-form-group>
          </div>
          <button type="button" v-on:click="addZone()" class="btn btn-primary" ><i class="fa fa-plus"></i> Adicionar código</button>
        </b-card>
      </b-col>
    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'DealersEdit',
  props: ['id'],
  data() {
    return {
      item: {
        name: '',
        code: '',
        dealerufs: {
          data: []
        },
        zones: {
          data: []
        },
        dealersellin: {
          data: []
        }
      },
      stateOptions: lists.states,
      dealerTypes: lists.dealerTypes
    }
  },
  methods: {
    addDealerUFS() {
      this.item.dealerufs.data.push({})
    },
    removeDealerUFS(i) {
      this.item.dealerufs.data.splice(i,1)
    },
    addDealerSellin() {
      this.item.dealersellin.data.push({})
    },
    removeDealerSellin(i) {
      this.item.dealersellin.data.splice(i,1)
    },
    addZone() {
      this.item.zones.data.push({})
    },
    removeZone(i) {
      this.item.zones.data.splice(i,1)
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('dealers' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'dealers.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('dealers', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'dealers.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('dealers' + '/' + id)
        .then(response => {
          this.item = response.data.data
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'dealers.index'
          })
        })
    }
  }
}
</script>
